import React, { useRef, useState } from 'react'
import ReactDOM from 'react-dom'

function InfoTooltip({ children }) {
    const ref = useRef(null)
    const [show, setShow] = useState(false)

    return (
        <>
      <span
          ref={ref}
          className="info-icon"
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
      >
        i
      </span>
            {show &&
                ReactDOM.createPortal(
                    <div
                        style={{
                            position: 'absolute',
                            top: ref.current.getBoundingClientRect().top + window.scrollY,
                            left:
                                ref.current.getBoundingClientRect().left +
                                window.scrollX +
                                ref.current.getBoundingClientRect().width +
                                8,
                            zIndex: 10000,
                        }}
                        className="tooltip-portal"
                    >
                        {children}
                    </div>,
                    document.getElementById('tooltip-root')
                )}
        </>
    )
}

export default InfoTooltip;